
import { getVilleSlug } from '~/plugins/boutique'

export default {
  name: 'BoutiqueGrid',
  props: {
    boutiques: {
      type: Array,
      required: true
    }
  },
  methods: { getVilleSlug }
}
